// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ShortStoriesCategories.module.css */
.ShortStoriesCategories_container__sE4R\\+ {
    width: 100%;
    max-width: 95%;
margin: 0 auto;
  }
  
 
  
  .ShortStoriesCategories_categoryHeader__h5OTf {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .ShortStoriesCategories_categoryTitle__z67KR {
    font-size: 1.5rem;
    font-weight: 600;
    color: #333;
  }
  
  .ShortStoriesCategories_viewAllLink__fz8xF {
    color: #0066cc;
    font-size: 0.9rem;
    cursor: pointer;
    text-decoration: none;
  }
  
  .ShortStoriesCategories_viewAllLink__fz8xF:hover {
    text-decoration: underline;
  }
  
  /* Grid Layout */
  .ShortStoriesCategories_audioGridContainer__f9nNe {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  
  .ShortStoriesCategories_audioGrid__4mD9Z {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 items in mobile view */
    gap: 10px;
    width: 100%;
  }
  
  .ShortStoriesCategories_gridItem__s5JJ8 {
    cursor: pointer;
    transition: transform 0.2s ease;
    position: relative;
    aspect-ratio: auto;
    overflow: hidden;
    border-radius: 5px;
  }
  
 
  .ShortStoriesCategories_bookImage__90EOm {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  
  
  /* Loading and error states */
  .ShortStoriesCategories_loading__IIJ54, .ShortStoriesCategories_error__T64qU, .ShortStoriesCategories_noContent__qiAgX, .ShortStoriesCategories_noCategories__SIg6O {
    text-align: center;
    background-color: #1a1a1a;
    border-radius: 8px;
    margin: 1rem 0;
  }
  
  .ShortStoriesCategories_loading__IIJ54 {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }
  
  .ShortStoriesCategories_error__T64qU {
    color: #dc3545;
  }
  
  .ShortStoriesCategories_noContent__qiAgX, .ShortStoriesCategories_noCategories__SIg6O {
    color: #6c757d;
    font-style: italic;
  }
  
  /* Media Queries for responsive design */
  @media (min-width: 768px) {
    .ShortStoriesCategories_audioGrid__4mD9Z {
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;
    }
  }
  
  @media (min-width: 992px) {
    .ShortStoriesCategories_audioGrid__4mD9Z {
      grid-template-columns: repeat(5, 1fr);
      gap: 15px;
    }
  }
  
  @media (min-width: 1200px) {
    .ShortStoriesCategories_audioGrid__4mD9Z {
      grid-template-columns: repeat(7, 1fr); /* 7 items in desktop view */
      gap: 20px;
    }
    
    .ShortStoriesCategories_categoryTitle__z67KR {
      font-size: 1.8rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/ShortStories/Component/CSS/ShortStoriesCategories.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,WAAW;IACX,cAAc;AAClB,cAAc;EACZ;;;;EAIA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,gBAAgB;EAChB;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qCAAqC,EAAE,2BAA2B;IAClE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;;;EAIA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA,wCAAwC;EACxC;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;EACF;;EAEA;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;EACF;;EAEA;IACE;MACE,qCAAqC,EAAE,4BAA4B;MACnE,SAAS;IACX;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["/* ShortStoriesCategories.module.css */\n.container {\n    width: 100%;\n    max-width: 95%;\nmargin: 0 auto;\n  }\n  \n \n  \n  .categoryHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .categoryTitle {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .viewAllLink {\n    color: #0066cc;\n    font-size: 0.9rem;\n    cursor: pointer;\n    text-decoration: none;\n  }\n  \n  .viewAllLink:hover {\n    text-decoration: underline;\n  }\n  \n  /* Grid Layout */\n  .audioGridContainer {\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .audioGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* 3 items in mobile view */\n    gap: 10px;\n    width: 100%;\n  }\n  \n  .gridItem {\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    position: relative;\n    aspect-ratio: auto;\n    overflow: hidden;\n    border-radius: 5px;\n  }\n  \n \n  .bookImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n  }\n  \n  \n  \n  /* Loading and error states */\n  .loading, .error, .noContent, .noCategories {\n    text-align: center;\n    background-color: #1a1a1a;\n    border-radius: 8px;\n    margin: 1rem 0;\n  }\n  \n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n  }\n  \n  .error {\n    color: #dc3545;\n  }\n  \n  .noContent, .noCategories {\n    color: #6c757d;\n    font-style: italic;\n  }\n  \n  /* Media Queries for responsive design */\n  @media (min-width: 768px) {\n    .audioGrid {\n      grid-template-columns: repeat(4, 1fr);\n      gap: 15px;\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .audioGrid {\n      grid-template-columns: repeat(5, 1fr);\n      gap: 15px;\n    }\n  }\n  \n  @media (min-width: 1200px) {\n    .audioGrid {\n      grid-template-columns: repeat(7, 1fr); /* 7 items in desktop view */\n      gap: 20px;\n    }\n    \n    .categoryTitle {\n      font-size: 1.8rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShortStoriesCategories_container__sE4R+`,
	"categoryHeader": `ShortStoriesCategories_categoryHeader__h5OTf`,
	"categoryTitle": `ShortStoriesCategories_categoryTitle__z67KR`,
	"viewAllLink": `ShortStoriesCategories_viewAllLink__fz8xF`,
	"audioGridContainer": `ShortStoriesCategories_audioGridContainer__f9nNe`,
	"audioGrid": `ShortStoriesCategories_audioGrid__4mD9Z`,
	"gridItem": `ShortStoriesCategories_gridItem__s5JJ8`,
	"bookImage": `ShortStoriesCategories_bookImage__90EOm`,
	"loading": `ShortStoriesCategories_loading__IIJ54`,
	"error": `ShortStoriesCategories_error__T64qU`,
	"noContent": `ShortStoriesCategories_noContent__qiAgX`,
	"noCategories": `ShortStoriesCategories_noCategories__SIg6O`
};
export default ___CSS_LOADER_EXPORT___;
